import { render, staticRenderFns } from "./feesAim.vue?vue&type=template&id=035d0e3e&scoped=true"
import script from "./feesAim.vue?vue&type=script&lang=js"
export * from "./feesAim.vue?vue&type=script&lang=js"
import style0 from "./feesAim.vue?vue&type=style&index=0&id=035d0e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d0e3e",
  null
  
)

export default component.exports